// extracted by mini-css-extract-plugin
module.exports = {"c":"styles_c__3cqBa","front":"styles_front__1V5ci","back":"styles_back__23_Rl","container":"styles_container__uP2Oo"};